// NOTE: hooks
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
// NOTE: components
import NavBar from './NavBar'
import { PageErrorBoundaryWrapper } from '../errorBoundary/ErrorBoundary'

interface LayoutProps {
	links: any[]
	home: string
}

const Layout = ({ links, home }: LayoutProps) => {
	const location = useLocation()

	// NOTE: the router swaps pages without a reload, so the window keeps the previous page's scroll unless it is reset here
	useEffect(() => {
		if (!location.hash) window.scrollTo(0, 0)
	}, [location.pathname, location.hash])

	return (
		// TODO: min-h-screen min-h-svh
		<div className="flex w-full">
			<NavBar links={links} home={home} />
			<PageErrorBoundaryWrapper key={location.pathname} className="w-full">
				<Outlet />
			</PageErrorBoundaryWrapper>
		</div>
	)
}

export default Layout